/*jshint esversion: 6 */

import React, { Component } from 'react';
import OnlyText from "../Templates/OnlyText.js";
import FbTimelineNarrow from "../Templates/FbTimelineNarrow.js";
import FbTimelineWide from "../Templates/FbTimelineWide.js";
import Manus from "../Templates/Manus.js";
import Gmap from "../Templates/Gmap.js";
import ImageSlider from "../Templates/ImageSlider.js";
import * as strFuncs from "../utils/stringFuncs.js";
import '../css/utils.css';

export function renderPage(pageObject, isSub = false){
    const rows = [];
    if(pageObject){
        let isParent = pageObject.subPageObjects? true : false;
        if(pageObject.paragraphObjects){
            pageObject.paragraphObjects.map((p, i)=>{
                var isOdd = (i%2 === 0);
                let templateObjArr = p.displayTemplate;
                if(templateObjArr){
                    if(templateObjArr.length){
                        let templateObj = templateObjArr[0];
                        let templateHeader = templateObj.header;
                        //console.log('templateObj', templateObj);
                        if(templateObj.hasExternalApi){
                            //console.log("FbTimelineNarrow", p.facebook_header, p.facebook_link)
                            rows.push(
                            <div  key={i} clear_div  className={"clear_div template_container_" + templateHeader + "container_" + isOdd}>
                                {(templateHeader === 'intro_fb')?
                                    <div key={'ffn'+i}  className="two_col_container" >
                                    <OnlyText key={'fnot'+i}
                                        header = {p.header}
                                        content={p.content}
                                        templateHeader = {templateHeader}
                                        isSub = {isSub}
                                        isParent = {isParent}
                                    />
                                    <FbTimelineNarrow  key={'fn'+i}
                                        header = {p.facebook_header}
                                        fbLink={p.facebook_link}
                                        isSub = {isSub}
                                        isParent = {isParent}
                                    />
                                    </div>
                                    :
                                    <div key={'ffw'+i} className={templateHeader}>
                                    <OnlyText key={'fwot'+i}
                                        header = {p.header}
                                        content={p.content}
                                        templateHeader = {templateHeader}
                                        isSub = {isSub}
                                        isParent = {isParent}
                                    />
                                    <FbTimelineWide key={'fw'+i}
                                        header = {p.facebook_header}
                                        fbLink={p.facebook_link}
                                        isSub = {isSub}
                                        isParent = {isParent}
                                    />
                                    </div>
                                }
                            </div>
                            );
                        }
                        else if(templateHeader === "slide_show"){
                            let sliderImages = [];
                            p.manusObjects.map(mo =>{
                            sliderImages.push(mo.links.file);
                            });
                            rows.push(
                            <ImageSlider  key={'is'+i}
                                sliderImages = {sliderImages}
                            />
                            );
                        }
                        else if(templateObj.hasImage || templateObj.hasMultipleImages || p.manusObjects.length){
                            rows.push(
                            <div  key={i} className={templateHeader}>
                                <Manus
                                keyi = {i}
                                manuses={p.manusObjects}
                                header = {p.header}
                                content={p.content}
                                templateObj={templateObj}
                                />
                            </div>
                            );
                        }
                        else if(templateObj.hasGmap){
                            rows.push(
                            <div  key={i} className={templateHeader}>
                                <Gmap
                                keyi = {i}
                                gmapUrl={p.external_url}
                                header = {p.header}
                                content={p.content}
                                templateObj={templateObj}
                                height = {400}
                                width = {900}
                                />
                            </div>
                            );
                        }
                        else{
                            rows.push(
                            <div key={i} className={templateHeader}>
                                <OnlyText
                                    header = {p.header}
                                    content={p.content}
                                    templateHeader = {templateHeader}
                                    isSub = {isSub}
                                    isParent = {isParent}
                                />
                            </div>
                            );
                        }
                        }
                    }
            });
        }
    }
    
    return rows;
  }


// WEBPACK FOOTER //
// ./src/utils/Renderer.js